'use client';

import React from 'react';

import { useShoppingCartContext } from '@/components/Providers/ShoppingCartProvider';
import ButtonLink from '@/components/V2/ButtonLink';

const ContinueShoppingBtn = ({ link }: { link: string }) => {
  const { isEnrollmentFlow } = useShoppingCartContext();

  return (
    <>
      {isEnrollmentFlow && (
        <ButtonLink
          href={link}
          scheme="primary"
          variant="outlined"
          className="v2-mx-auto v2-font-sweet-sans-pro !v2-p-2 v2-text-lg v2-leading-[30px] v2-text-center"
        >
          Continue Shopping
        </ButtonLink>
      )}
    </>
  );
};

export default ContinueShoppingBtn;
